import { SessionStorage } from '~/models'

export const useNewsletterSubscriber = () => {
  const subscriberEmail = useSessionStorage<string | null>(SessionStorage.NewsletterSubscribeUserEmail, null)

  const setSubscriberEmail = (value: string) => set(subscriberEmail, value)

  return {
    subscriberEmail,
    setSubscriberEmail,
  }
}
